import { AbstractCallService, type UserCallInfo } from "./abstractCallService";
import type { ArtichokeService } from "./artichokeService";
import { logger } from "../utils/logger";
import { Call } from "@closerplatform/sdk/src";

export class PopoutCallService extends AbstractCallService {
  constructor(artichokeService: ArtichokeService) {
    super(artichokeService);
  }

  protected handleCallEnded(_: Call): void {
    return;
  }

  public async connect(callId: string, userId: string, agentId: string, audioTrack: MediaStreamTrack): Promise<UserCallInfo> {
    logger.debug("CallService: calling to agent", agentId);
    if (this.currentCall) {
      throw new Error("Can't call, there is a call in progress already");
    }

    const call = await this.artichokeService.getCall(callId);
    this.handleNewCall(call);
    call.addTracks([audioTrack]);
    this.currentLocalAudioTrack = audioTrack;
    if (call.recordingEnabled) {
      call.joinRecordingCall(userId, agentId);
    }
    return { callId: call.id, remoteUserId: agentId };
  }
}
